import { LockIcon } from "@/shared/icons";
import PlayerMenuCharacterDataCard from "@/domains/playerMenu/components/character/data/PlayerMenuCharacterDataCard";
import PlayerMenuCharacterFadeBox from "@/domains/playerMenu/components/character/data/PlayerMenuCharacterFadeBox";

export default function PlayerMenuCharacterBattlePassCardContainer() {
  return (
    <PlayerMenuCharacterDataCard
      style={{
        backgroundImage:
          "linear-gradient(131deg, rgba(205, 23, 23, 0.10) 0%, rgba(22, 22, 22, 0.10) 46.48%)",
      }}
    >
      <div className="flex flex-col w-full h-full">
        <div className="flex flex-col items-center">
          <div className="w-full relative flex items-center gap-3.5 overflow-clip">
            <PlayerMenuCharacterFadeBox icon={LockIcon} color="accent" />
            <div>
              <div className="text-13 font-bold uppercase">НЕДОСТУПЕН</div>
              <div className="text-10 font-bold text-accent-solid uppercase mt-1">
                СКОРО ПОЯВИТСЯ
              </div>
            </div>
          </div>
        </div>
        <div className="mt-auto text-18 font-bold">Боевой пропуск</div>
      </div>
    </PlayerMenuCharacterDataCard>
  );
}
